/**
 * Site-wide schema.org entity graph (approved 2026-10-23). Every node has a
 * stable @id so articles and pages reference the same business and person.
 */
const B = "https://drsaranahas.com";
const SAME_AS = [
  "https://www.instagram.com/dr.saraalnahas",
  "https://www.tiktok.com/@dr.saraalnahas",
  "https://www.youtube.com/@dr.saraalnahas1",
  "https://www.facebook.com/DrSaraAlnahhas",
  "https://www.threads.com/@dr.saraalnahas",
];

export const PERSON_ID = `${B}/#person`;
export const BUSINESS_ID = `${B}/#business`;
export const WEBSITE_ID = `${B}/#website`;
export const CONSULTATION_ID = `${B}/#service-consultation`;

export const ENTITY_GRAPH = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "ProfessionalService",
      "@id": BUSINESS_ID,
      name: "د. سارة النحّاس — استشارات تربوية ونفسية",
      alternateName: "Dr. Sara Alnahhas — Parenting and Educational Consultations",
      url: `${B}/`,
      logo: `${B}/logo.png`,
      image: `${B}/og/default.png`,
      description:
        "استشارات تربوية ونفسية للأهل، أونلاين من أي بلد أو بالعيادة في أبو رمانة بدمشق، مع مدوّنة تربوية بالعربية والبوصلة الدراسية المجانية لاختيار التخصص الجامعي.",
      telephone: "+963958645116",
      email: "hi@drsaranahas.com",
      founder: { "@id": PERSON_ID },
      address: { "@type": "PostalAddress", streetAddress: "أبو رمانة", addressLocality: "دمشق", addressCountry: "SY" },
      areaServed: [{ "@type": "City", name: "دمشق" }, { "@type": "Country", name: "Syria" }, "Online — any country"],
      knowsLanguage: ["ar", "en"],
      currenciesAccepted: "USD",
      paymentAccepted: "PayPal (outside Syria), Sham Cash, Al-Haram transfer (inside Syria), cash at the clinic",
      makesOffer: [
        { "@type": "Offer", name: "استشارة تربوية فردية — 45 دقيقة", url: `${B}/book`, price: "75", priceCurrency: "USD", itemOffered: { "@id": CONSULTATION_ID } },
        { "@type": "Offer", name: "باقة شهرية — 4 استشارات", url: `${B}/book`, price: "250", priceCurrency: "USD", itemOffered: { "@id": CONSULTATION_ID } },
        { "@type": "Offer", name: "البوصلة الدراسية — اختبار مجاني", url: `${B}/bousala`, price: "0", priceCurrency: "USD" },
        { "@type": "Offer", name: "البوصلة الذكية — تقرير مفصّل", url: `${B}/bousala/smart`, price: "10", priceCurrency: "USD" },
      ],
      sameAs: SAME_AS,
    },
    {
      "@type": "Person",
      "@id": PERSON_ID,
      name: "د. سارة النحّاس",
      alternateName: "Dr. Sara Alnahhas",
      honorificPrefix: "د.",
      jobTitle: "استشارية تربوية ونفسية",
      description:
        "دكتوراه في التربية من جامعة دمشق (2023). تعمل مع الأهل والطلاب في العالم العربي والمهجر، أونلاين وبالعيادة في أبو رمانة بدمشق. المنهج: التربية الحساسة للصدمات وعلم الأعصاب.",
      url: `${B}/about`,
      image: `${B}/dr-sara.jpg`,
      email: "hi@drsaranahas.com",
      worksFor: { "@id": BUSINESS_ID },
      alumniOf: { "@type": "CollegeOrUniversity", name: "جامعة دمشق", alternateName: "Damascus University" },
      hasCredential: [
        { "@type": "EducationalOccupationalCredential", name: "دكتوراه في التربية", alternateName: "PhD in Education", credentialCategory: "degree", dateCreated: "2023", recognizedBy: { "@type": "CollegeOrUniversity", name: "جامعة دمشق" } },
        { "@type": "EducationalOccupationalCredential", name: "ماجستير في تعليم اللغة العربية", credentialCategory: "degree", dateCreated: "2019", recognizedBy: { "@type": "CollegeOrUniversity", name: "المعهد العالي للغات، جامعة دمشق" } },
        { "@type": "EducationalOccupationalCredential", name: "إجازة في الآداب، قسم اللغة العربية وآدابها", credentialCategory: "degree", dateCreated: "2014", recognizedBy: { "@type": "CollegeOrUniversity", name: "جامعة دمشق" } },
        { "@type": "EducationalOccupationalCredential", name: "دبلوم التأهيل التربوي", credentialCategory: "diploma", recognizedBy: { "@type": "CollegeOrUniversity", name: "جامعة دمشق" } },
      ],
      knowsAbout: ["تربية الطفل", "علم نفس الطفل", "التربية الحساسة للصدمات", "التوجيه الدراسي والمهني"],
      knowsLanguage: ["ar", "en"],
      sameAs: SAME_AS,
    },
    {
      "@type": "Service",
      "@id": CONSULTATION_ID,
      name: "استشارة تربوية فردية مع د. سارة النحّاس",
      alternateName: "One-to-one parenting consultation with Dr. Sara Alnahhas",
      serviceType: "استشارة تربوية ونفسية للأهل",
      url: `${B}/book`,
      provider: { "@id": BUSINESS_ID },
      areaServed: ["Online — any country", { "@type": "City", name: "دمشق" }],
      availableChannel: [
        { "@type": "ServiceChannel", name: "واتساب العيادة — للاتفاق على الموعد", servicePhone: { "@type": "ContactPoint", telephone: "+963958645116", contactType: "bookings" } },
        { "@type": "ServiceChannel", name: "طلب الحجز أونلاين", serviceUrl: `${B}/book` },
      ],
      audience: { "@type": "Audience", audienceType: "الأهل — الطفولة المبكرة والمتوسطة" },
      description:
        "جلسة فردية 45 دقيقة مع د. سارة، أونلاين من أي بلد أو بالعيادة في دمشق. المراسلة على واتساب أولاً للاتفاق على اليوم والساعة، ثم طلب الحجز مع استمارة قصيرة عن الطفل. كل المبيعات نهائية.",
      offers: [
        { "@type": "Offer", name: "جلسة واحدة — 45 دقيقة", price: "75", priceCurrency: "USD" },
        { "@type": "Offer", name: "باقة شهرية — 4 جلسات", price: "250", priceCurrency: "USD" },
      ],
    },
    {
      "@type": "WebSite",
      "@id": WEBSITE_ID,
      url: `${B}/`,
      name: "د. سارة النحّاس — منصّة التربية والعلاقة الآمنة",
      alternateName: "Dr. Sara Alnahhas",
      inLanguage: "ar",
      publisher: { "@id": BUSINESS_ID },
    },
  ],
} as const;

export const BOOK_PAGE_LD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": `${B}/book#webpage`,
      url: `${B}/book`,
      name: "حجز استشارة مع د. سارة النحّاس",
      inLanguage: "ar",
      isPartOf: { "@id": WEBSITE_ID },
      mainEntity: { "@id": CONSULTATION_ID },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "الرئيسية", item: `${B}/` },
        { "@type": "ListItem", position: 2, name: "حجز استشارة", item: `${B}/book` },
      ],
    },
  ],
};

/** Word count of a markdown body (markup stripped). */
export function wordCount(md: string | null | undefined): number {
  const text = (md ?? "").replace(/<[^>]+>/g, " ").replace(/[#>*_`|\[\]()!-]/g, " ");
  return text.split(/\s+/).filter(Boolean).length;
}
